export default {
    add: 'Create new post',

    empty: {
        first: 'Add first post',
        title: 'Looking for content?',
        content: 'Unfortunately, there is nothing to see here yet.<br />Create a post!'
    }
}
